import {
  APP_INITIALIZER,
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
} from '@angular/core';
import {
  UnleashService,
  UNLEASH_CONFIG,
} from '@karelics/angular-unleash-proxy-client';
import { filter, switchMap, take, tap } from 'rxjs';
import { IConfig as UnleashConfig } from 'unleash-proxy-client';
import { AuthFacade } from '../auth/store/facades/auth.facade';

// This provide is based on the provideUnleashProxy
// but it adds the user context to the unleash config
// before starting the unleash service
// Based on: https://github.com/Karelics/angular-unleash-proxy-client/blob/15.x/projects/angular-unleash-proxy-client/src/lib/unleash.initializer.ts
export function provideUnleashProxyWithUserContext(
  config: UnleashConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: UNLEASH_CONFIG,
      useValue: config,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const unleashService = inject(UnleashService);
        const authFacade = inject(AuthFacade);

        return () => {
          return unleashService.initialized$.pipe(
            take(1),
            switchMap(() => authFacade.authRenderState$),
            // Only start the unleash service if the auth render state is finalized
            filter((authState) => authState !== 'loading'),
            switchMap(() => authFacade.user$),
            tap((user) => {
              // Update Unleash context with user information
              unleashService.unleash.updateContext({
                userId: user?.sub ?? 'logoutUser',
              });
            }),
            tap(() => {
              // Start Unleash service
              unleashService.unleash.start();
            }),
            take(1),
          );
        };
      },
      multi: true,
    },
  ]);
}
